// import React from 'react'

import img1 from "../../media/images/GurugramContent1.jpg";
import img2 from "../../media/images/GurugramContent2.jpg";

const LocationContentNoida = () => {
  return (
    <div>
      <div className="location-content">
        <div className="location-content-main">
          <div className="location-content-main-img">
            <img src={img1} title="Pet Groomers Near Me" alt="offer-imh" />
          </div>

          <div className="location-content-section">
            <h3 className="location-content-heading">
              Stress-Free <span>Pet Grooming</span> at Home in{" "}
              <span>Noida</span> | FluffyTouch
            </h3>
            <div className="location-content-text">
              📞 One-Call Service: 96581 89189 | 📍 Serving: Sector 62, 76, 128,
              Sector 62 IT Hub, Sector 76–Metro Zone, Sector 137–Expressway,
              Gaur City, Noida Extension, Noida-Greater Noida Expressway, Noida
              City Centre, Botanical Garden Area, Jewar Airport Zone Hub and
              more.
              {/* Looking for pet grooming in Noida? FluffyTouch brings dog grooming near me
              and cat grooming at home straight to your door. No more dragging
              your furry buddy to a salon—our pro groomers make your pet look
              and feel amazing right at home. Grooming isn’t just about looks;
              it keeps your pet’s skin healthy, cuts down on fur mess, and makes
              them a happy camper! */}
            </div>

            <div className="location-content-image">
              <img src={img2} title="Pet Groomers Near Me" alt="offer-imh" />
            </div>

            <section>
              <div className="location-content-sub-heading">
                Noida Pet Problems? We Get It!
              </div>
              <div className="location-content-text">
                <ul>
                  <li>
                    Hate dragging your Shih Tzu through Noida traffic to salons?
                  </li>
                  <li>
                    Worried about your Persian cat's matted fur in humid Noida
                    weather?
                  </li>
                  <li>Tired of overpriced salons near DLF Mall?</li>
                </ul>
                We Bring The Solution To Your Doorstep!
              </div>

              <div className="location-content-sub-heading">
                Noida's Most Trusted Grooming
              </div>
              <div className="location-content-text">
                ✔ Monsoon Special: Anti-fungal baths (July-Sept)
                <br />✔ Winter Care: Moisturizing paw balm (Nov-Jan)
                <br />✔ Breed Experts: From indie street dogs to fancy Poodles
              </div>

              <div className="location-content-sub-heading">
                Why Noida Loves Us?
              </div>
              <div className="location-content-text">
                <ul>
                  <li>
                    Sector-Wise Groomers: Dedicated staff for East/West Noida
                  </li>
                  <li>
                    Apartment-Friendly: Works in all high-rises (even with lift
                    issues!)
                  </li>
                  <li>
                    Local Knowledge: Best routes to beat Noida-Greater Noida
                    Expressway traffic
                  </li>
                </ul>
              </div>

              <div className="location-content-sub-heading">
                Book in 2 Noida Minutes!
              </div>
              <div className="location-content-text">
                <ol>
                  <li>WhatsApp "GROOM" to 96581 89189</li>
                  <li>Get instant slot confirmation</li>
                  <li>Enjoy ₹200 OFF first booking (Noida special!)</li>
                </ol>
              </div>
            </section>

            <div className="location-content-sub-heading">
              Real Noida Pet Stories
            </div>
            <div className="location-content-text">
              "My Labrador from Sector 100 used to hate grooming - now he wags
              his tail when FluffyTouch arrives!" - Priya K., Gaur City
              <br />
              "Finally found someone who understands Persian cat anxiety near
              Noida Stadium!" - Rohan, Sector 50
              {/* Make your dog or cat the talk of the town with FluffyTouch’s pet
              grooming at home in Noida. Book now for a squeaky-clean,
              tail-wagging pet! 📞 Call Us or 💬 WhatsApp Now to lock in a slot! */}
            </div>

            <div className="location-content-sub-heading"></div>
            <div className="location-content-text"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationContentNoida;
